export { default } from "./RichTextParagraph";
